/**
 * Smart Lock · Geräte — Route-Shell (Sprint 24, C2).
 *
 * Bewusst nur Gerüst: kein Backend, keine Datenanbindung, kein finales Design.
 * Der Smart-Lock-Vendor wird extern geklärt; sobald er steht, ersetzt eine
 * echte Geräte-Liste + CRUD diesen Platzhalter (dockt am leeren
 * `Modules.SmartLock` an).
 */
import { EmptyState, PageHeader } from '@/shared/components';

export function SmartLockDevicesPage() {
  return (
    <>
      <PageHeader
        eyebrow="Smart Lock"
        title="Geräte"
        titleAccent="& Schlösser"
        description="Verwaltung der Smart-Lock-Geräte. Anbindung folgt mit der Vendor-Integration."
      />
      <EmptyState
        icon="Lock"
        title="Noch keine Geräte-Anbindung"
        description="Der Geräte-Katalog (Anlegen, Bearbeiten, Entfernen) wird aktiviert, sobald der Smart-Lock-Vendor angebunden ist."
      />
    </>
  );
}
